// extracted by mini-css-extract-plugin
module.exports = {"QuestionAndFill":"QuestionAndFill_QuestionAndFill__35MDq","Task":"QuestionAndFill_Task__3GOZP"};